import { createReducer, FAILURE, SUCCESS, updateObject } from 'Stores'
import {
  GET_PLAN
} from './constants'

export const initialState = {
  isLoading: false,
  error: null,
  plan: ''
}

function getPlanSuccess(state, { payload }) {
  const { plan } = payload
  return updateObject(state, {
    plan
  })
}

function getPlanFail(state) {
  return updateObject(state, {
    plan: ''
  })
}

// Slice reducer
export default createReducer(initialState, {
  [SUCCESS(GET_PLAN)]: getPlanSuccess,
  [FAILURE(GET_PLAN)]: getPlanFail
})
